module.exports = __webpack_public_path__ + "static/media/sr-SP.fe0fae59.md";